import { render, staticRenderFns } from "./TestItemJudge.vue?vue&type=template&id=a21a64ee&scoped=true&"
import script from "./TestItemJudge.vue?vue&type=script&lang=js&"
export * from "./TestItemJudge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21a64ee",
  null
  
)

export default component.exports